var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:{
    'user-search--home': _vm.home,
    'user-search--header': _vm.header,
    'my-2': true,
    'pr-2 pl-4 py-2': true,
    'has-error': _vm.error === true,
    'no-error': _vm.error === false
  },on:{"submit":function($event){$event.preventDefault();return _vm.findUser(_vm.userId)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userId),expression:"userId"}],class:{
      'subheading': _vm.subheading,
      'body-2': _vm.body2,
      'font-weight-light': _vm.fontWeightLight,
      'white--text': _vm.whiteText
     },attrs:{"placeholder":"введите ID студента"},domProps:{"value":(_vm.userId)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.userId=$event.target.value},function($event){return _vm.validateID(_vm.userId)}]}}),_c('v-icon',{staticClass:"ml-2",attrs:{"size":_vm.iconSize,"color":"warning"}},[_vm._v("search")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }